module.exports = __webpack_public_path__ + "img/wolf_600.2dfa1c79.png";